const DayRangePlusMinus45 = {
  min: -45,
  max: 45,
  step: 1,
  marks: [
    { value: -45, label: "-45 Days"},
    { value: -30, label: "-30 Days" },
    { value: -15, label: "-15 Days" },
    { value: 0, label: "Today" },
    { value: 15, label: "+15 Days" },
    { value: 30, label: "+30 Days" },
    { value: 45, label: "45 Days"},
  ]
};

const DayRange0To20 = {
  min: 0,
  max: 20,
  step: 0.1,
  marks: [
    { value: 0, label: "0 Days" },
    { value: 5, label: "5" },
    { value: 10, label: "10" },
    { value: 15, label: "15" },
    { value: 20, label: "20 Days" },
  ]
};

const StarRating = {
  min: 1,
  max: 5,
  step: 1,
  marks: [
    { value: 1, label: "1 Stars" },
    { value: 2, label: "2" },
    { value: 3, label: "3" },
    { value: 4, label: "4" },
    { value: 5, label: "5" },
  ]
};

const CountTen = {
  min: 0,
  max: 10,
  step: 1,
  marks: [
    { value: 0, label: "0" },
    { value: 5, label: "5" },
    { value: 10, label: "10" },
  ]
};

const RangeZeroToOneHundred = {
  min: 0,
  max: 100,
  step: 5,
  marks: [
    { value: 0, label: "0" },
    { value: 25, label: "25" },
    { value: 50, label: "50" },
    { value: 75, label: "75" },
    { value: 100, label: "100" },
  ]
};

const RangeZeroToTwoHundred = {
  min: 0,
  max: 200,
  step: 5,
  marks: [
    { value: 0, label: "0" },
    { value: 50, label: "50" },
    { value: 100, label: "100" },
    { value: 150, label: "150" },
    { value: 200, label: "200" },
  ]
};

const HourRangeZeroToFortyEight = {
  min: 0,
  max: 48,
  step: 1,
  marks: [
    { value: 0, label: "0 Hours" },
    { value: 12, label: "12" },
    { value: 24, label: "24" },
    { value: 36, label: "36" },
    { value: 48, label: "48 Hours" },
  ]
};

const WeekRange0To16 = {
  min: 0,
  max: 16,
  step: 1,
  marks: [
    { value: 0, label: "0 Weeks" },
    { value: 4, label: "4 Weeks" },
    { value: 8, label: "8 Weeks" },
    { value: 12, label: "12 Weeks" },
    { value: 16, label: "16 Weeks" },
  ]
};

export {
  DayRangePlusMinus45,
  DayRange0To20,
  StarRating,
  CountTen,
  RangeZeroToOneHundred,
  RangeZeroToTwoHundred,
  HourRangeZeroToFortyEight,
  WeekRange0To16
};
